import { formatPrice } from "../../../../utils"

export function getCartSum(cart: CartItem[], vat: number): CartSum {
    const sum: CartSum = {
        subtotalNet: 0,
        subtotalGross: 0,
        minQtyNet: 0,
        minQtyGross: 0,
        packagingNet: 0,
        packagingGross: 0,
        shippingNet: 0,
        shippingGross: 0,
        totalNet: 0,
        totalGross: 0,
        totalVAT: 0,
    }

    cart.forEach((c) => {
        sum.subtotalNet += formatPrice(c.price.unit, 0, 1, false) as number
        sum.subtotalGross += formatPrice(c.price.unit, vat, 1, false) as number
    })
    sum.totalNet = sum.subtotalNet
    sum.totalGross = sum.subtotalGross
    sum.totalVAT = formatPrice(sum.totalGross - sum.totalNet, 0, 1, false) as number
    return sum
}
